import React from 'react';

import classNames from 'classnames';

import { EXCEPTION_CELL_CLASS, OpenRowButton, orNotSet } from '../HomeSection';

import { ActionCounts, PriorityBadge, StatusBadge } from './rowBadges';

import { formatDateWithYear } from 'Helpers/dateTimeService';

/**
 * The user's issues, with the R.A.D.I.O. issue register's columns.
 *
 * AN OVERDUE ROW IS MARKED WITH A RULE DOWN ITS LEADING EDGE, not a wash across
 * the whole row — see EXCEPTION_CELL_CLASS.
 */
export default function IssueSectionTable({ rows = [], onRowClick }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Description')}</th>
                        <th className="tw-w-32">{$t('Status')}</th>
                        <th className="tw-w-28">{$t('Priority')}</th>
                        <th className="tw-w-36">{$t('Resolution Date')}</th>
                        <th className="tw-w-24">{$t('Actions (Outstanding)')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id} onClick={() => onRowClick?.(row)} className="tw-cursor-pointer">
                            <td className={classNames({ [EXCEPTION_CELL_CLASS]: row.overdue })}>
                                <OpenRowButton onClick={() => onRowClick?.(row)} label={$t('Open {{item}}', { item: row.description })}>
                                    {row.description}
                                </OpenRowButton>
                            </td>
                            <td>
                                <StatusBadge status={row.status} />
                            </td>
                            <td>
                                <PriorityBadge priority={row.priority} />
                            </td>
                            <td className="inbud-date-cell">{orNotSet(row.resolution_date && formatDateWithYear(row.resolution_date))}</td>
                            <td className="inbud-numeric-cell">
                                <ActionCounts total={row.actions_total} outstanding={row.actions_outstanding} />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
